import { render, staticRenderFns } from "./welcomPage.vue?vue&type=template&id=694c5a54&scoped=true&"
import script from "./welcomPage.vue?vue&type=script&lang=js&"
export * from "./welcomPage.vue?vue&type=script&lang=js&"
import style0 from "./welcomPage.vue?vue&type=style&index=0&id=694c5a54&lang=scss&scoped=true&"
import style1 from "./welcomPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c5a54",
  null
  
)

export default component.exports